import { Injectable } from '@angular/core';
import {
  BulkFirmwareDeviceUpdateRequest,
  BulkFirmwareUpdateResponse,
  BulkStartFirmwareUpdateRequest,
  BulkStartFirmwareUpdateResponse,
  DeactivateFirmwareResponse,
  FirmwareCatalogueFilter,
  FirmwareDeviceUpdateRequest,
  FirmwareModel,
  StartFirmwareUpdateRequest,
  StartFirmwareUpdateResponse,
} from '@core/models';
import { ApiService } from '@core/services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FirmwareService {
  constructor(private readonly apiService: ApiService) {}

  getFirmwareVersions(filter: FirmwareCatalogueFilter = {}): Observable<FirmwareModel[]> {
    return this.apiService.get<FirmwareModel[]>('/devices/firmware-versions', { ...filter });
  }

  deactivateFirmware(firmwareId: number): Observable<DeactivateFirmwareResponse> {
    return this.apiService.patch(`/devices/firmware-versions/${firmwareId}/deactivate`);
  }

  updateDeviceFirmware(request: FirmwareDeviceUpdateRequest): Observable<void> {
    return this.apiService.post('/firmware/devices/update', request);
  }

  bulkUpdateDeviceFirmware(
    request: BulkFirmwareDeviceUpdateRequest,
  ): Observable<BulkFirmwareUpdateResponse> {
    return this.apiService.post('/firmware/devices/bulk-update', request);
  }

  startDlmsFirmwareUpdate(
    deviceId: string,
    request: StartFirmwareUpdateRequest,
  ): Observable<StartFirmwareUpdateResponse> {
    return this.apiService.post(`/devices/start-firmware-update/${deviceId}`, request);
  }

  startBulkDlmsFirmwareUpdate(
    request: BulkStartFirmwareUpdateRequest,
  ): Observable<BulkStartFirmwareUpdateResponse> {
    return this.apiService.post('/devices/start-firmware-update', request);
  }
}
